<ng-container *ngIf="pagePointers$ | async as pagePointers">
  <ul *ngIf="pagePointers?.length">
    <!-- go previous -->
    <li class="arrow" [class.disabled]="isFirstPageSelected$ | async" (click)="$pageAdjuster.next(-1)">
      <mat-icon>chevron_left</mat-icon>
    </li>

    <!-- page list -->
    <li *ngFor="let pointer of pagePointers" (click)="this.$selectedPage.next(pointer.index)" [class.active]="(this.selectedPage$ | async) === pointer.index">{{ pointer.text }}</li>

    <!-- go next -->
    <li class="arrow" [class.disabled]="isLastPageSelected$ | async" (click)="$pageAdjuster.next(1)">
      <mat-icon>chevron_right</mat-icon>
    </li>
  </ul>
  <!-- filteredItems {{ filteredItems$ | async }} -->
</ng-container>
